// playbookLaunchProgress.js

/**
 * Maps mint/launch progress payloads into a label + percent for the Start modal.
 *
 * @param {object|null} progress
 * @returns {{ label: string, percent: number }}
 */
export function resolvePlaybookLaunchProgress(progress = null) {
  const phase = String(progress?.phase || '').trim();
  const completed = Math.max(0, Number(progress?.completed) || 0);
  const total = Math.max(0, Number(progress?.total) || 0);

  switch (phase) {
    case 'preparing':
      return {
        label: total > 0 ? `Preparing ${total} steps…` : 'Preparing steps…',
        percent: 8,
      };
    case 'creating':
      return {
        label: total > 0 ? `Creating ${total} steps…` : 'Creating steps…',
        percent: 28,
      };
    case 'linking':
      return {
        label: 'Linking steps to this record…',
        percent: 52,
      };
    case 'checklists': {
      const checklistTotal = Math.max(total, 1);
      const ratio = Math.min(1, completed / checklistTotal);
      return {
        label: total > 0
          ? `Seeding checklists (${completed}/${total})…`
          : 'Seeding checklists…',
        percent: Math.round(58 + (ratio * 22)),
      };
    }
    case 'resources':
      return {
        label: 'Linking checklist resources…',
        percent: 86,
      };
    case 'saving':
      return {
        label: 'Saving playbook…',
        percent: 94,
      };
    case 'done':
      return {
        label: 'Almost ready…',
        percent: 100,
      };
    default:
      return {
        label: 'Starting…',
        percent: 5,
      };
  }
}
